(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/init.js');
"use strict";


svs.eInstant.logger = new svs.core.log.Logger('module:tickets-einstant');
const {
  Route,
  PlayerRouter: Router
} = svs.app.ReactRouter;
const {
  LOBBY,
  FAVORITES,
  FAVORITES_INFO,
  CATEGORY,
  CATEGORY_INFO,
  INFO,
  PLAY,
  DEMO_PLAY,
  BET_DETAIL,
  ALL_GAMES,
  ALL_GAMES_INFO
} = svs.eInstant.constants.ROUTES;
const {
  LoginRequiredRoute
} = svs.eInstant.shared;
const EInstantRouter = _ref => {
  let {
    baseName = svs.core.data.baseUrl
  } = _ref;
  const {
    RouterProvider
  } = svs.eInstant.store;
  const {
    Lobby,
    Category,
    Play,
    AllGames,
    Info,
    Favorites
  } = svs.eInstant.lobby;
  const {
    Menu
  } = svs.eInstant.shared.components;
  const cancelUrl = svs.core.data.baseUrl + LOBBY;
  const isMobile = svs.core.detect.formfactor.mobile();
  const InfoComponent = isMobile ? Info : Lobby;
  return React.createElement(Router, {
    basename: baseName
  }, React.createElement(RouterProvider, null, React.createElement(Menu, null), React.createElement(Route, {
    component: Lobby,
    exact: true,
    path: LOBBY
  }), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Favorites,
    exact: true,
    path: FAVORITES
  }), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Favorites,
    exact: true,
    path: FAVORITES_INFO
  }), React.createElement(Route, {
    component: InfoComponent,
    exact: true,
    path: INFO
  }), React.createElement(Route, {
    component: Category,
    exact: true,
    path: CATEGORY
  }), React.createElement(Route, {
    component: Category,
    exact: true,
    path: CATEGORY_INFO
  }), React.createElement(Route, {
    component: AllGames,
    exact: true,
    path: ALL_GAMES
  }), React.createElement(Route, {
    component: AllGames,
    exact: true,
    path: ALL_GAMES_INFO
  }), React.createElement(Route, {
    component: Play,
    path: DEMO_PLAY
  }), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Play,
    exact: true,
    path: PLAY
  }), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Play,
    exact: true,
    path: BET_DETAIL
  })));
};
setGlobal('svs.eInstant.router.EInstantRouter', EInstantRouter);
const target = document.getElementById('reactContainer');
target && ReactDOM.render(React.createElement(EInstantRouter, null), target);

 })(window);